// Tableau.tsx
import { useAuth } from "@/features/Auth";
import { useEffect } from "react";

import Footer from "../Footer/Footer";
import TabViews from "./components/TabViews";
import TableauViz from "./components/TableauViz";

import useContentURL from "./hooks/useContentURL";
import useUUID from "./hooks/useUUID";
import useUserViews from "./hooks/useUserViews";
import useView from "./hooks/useView";

const Tableau = () => {
  // path url is /dashboard/:uuid
  // the view is a query parameter

  const { user } = useAuth();
  const { uuid } = useUUID(user.views);
  const { userViews } = useUserViews(uuid, user.views);
  const { view, switchView } = useView(uuid, userViews);
  const { contentURL } = useContentURL(view, userViews, uuid);

  useEffect(() => {
    document.title = view || "Quantilia";
  }, [view]);

  return (
    <main className="w-full overflow-y-hidden">
      <TabViews view={view} userViews={userViews} />
      <div className="relative">
        {uuid && contentURL && (
          <TableauViz
            uuid={uuid}
            view={view}
            contentURL={contentURL}
            switchView={switchView}
          />
        )}
      </div>
      <Footer />
    </main>
  );
};

export default Tableau;
